import { Title, Button, Input } from '@getinapp/appetizer';
import { Row, Col } from 'react-grid-system';
import { Lock } from '@styled-icons/boxicons-regular/Lock';
import Cards from 'react-credit-cards';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import 'react-credit-cards/es/styles-compiled.css';
import * as S from './styles';
import { useCreatePayment } from 'hooks/use-create-payment';
import { useAuth } from 'hooks/use-auth';
import { useLine } from 'hooks/use-line';
import { getPrice } from 'utils/helpers';

export type RemoteLineProps = {
  onPressBack: () => void;
  onSuccess: () => void;
  onError: () => void;
};

export const RemoteLineCreditCard = ({
  onSuccess,
  onError,
}: // onPressBack,
RemoteLineProps) => {
  const { t } = useTranslation();
  const { unit, settings, quantity } = useLine();
  const { mutate, isLoading } = useCreatePayment();
  const { user } = useAuth();

  const schema = Yup.object().shape({
    number: Yup.string()
      .trim()
      .required(t('@RemoteLineCreditCard.number-required')),
    holder_name: Yup.string()
      .trim()
      .required(t('@RemoteLineCreditCard.titular-name-required')),
    expiration: Yup.string()
      .trim()
      .required(t('@RemoteLineCreditCard.expiration-required')),
    security_code: Yup.string()
      .trim()
      .required(t('@RemoteLineCreditCard.security-code-required')),
  });

  const { values, handleChange, handleSubmit, errors, touched } = useFormik({
    initialValues: {
      number: '',
      holder_name: '',
      expiration: '',
      security_code: '',
    },
    validationSchema: settings?.pricing ? schema : {},
    onSubmit: (variables) => {
      if (user && unit) {
        const [month, year] = variables.expiration.split('/');
        mutate(
          {
            name: user.name,
            mobile: user.mobile,
            email: user.email,
            people: Number(quantity),
            payment_data: {
              card: {
                holder_name: variables.holder_name,
                number: variables.number.replace(/\s/g, ''),
                expiration_month: Number(month),
                expiration_year: Number(`20${year}`),
                security_code: variables.security_code,
              },
            },
            unit_id: unit.id,
          },
          {
            onSuccess: () => onSuccess(),
            onError: () => onError(),
          }
        );
      }
    },
  });

  const formikProps = (field: keyof typeof values) => ({
    value: values[field],
    error: touched[field] && errors[field] ? errors[field] : '',
    onChange: handleChange(field),
  });

  if (!unit || !settings) return null;

  return (
    <>
      <S.Header>
        <S.Avatar src={unit.profile_image} alt={unit.name} />
        <div>
          <Title>{unit.name}</Title>
          <p>Taxa de serviço</p>
          <b>{getPrice(settings.pricing / 100)}</b>
        </div>
      </S.Header>
      <S.Content>
        <form onSubmit={handleSubmit}>
          <Cards
            cvc={123}
            expiry={values.expiration}
            name={values.holder_name}
            locale={{ valid: '' }}
            number={values.number}
            placeholders={{
              name: t('@RemoteLineCreditCard.name-in-card'),
            }}
          />
          <br />

          <Row>
            <Col>
              <Input
                label={t('@RemoteLineCreditCard.card-number')}
                placeholder="1234 5678 9101 1121"
                mask="0000 0000 0000 0000"
                {...formikProps('number')}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Input
                label={t('@RemoteLineCreditCard.expiration')}
                placeholder="08/26"
                mask="00/00"
                {...formikProps('expiration')}
              />
            </Col>
            <Col>
              <Input
                label={t('@RemoteLineCreditCard.cvv')}
                placeholder="911"
                {...formikProps('security_code')}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Input
                label={t('@RemoteLineCreditCard.titular-name')}
                placeholder="Anakin Skywalker"
                {...formikProps('holder_name')}
              />
            </Col>
          </Row>

          <br />

          <Button isFullWidth loading={isLoading}>
            {t('@RemoteLineCreditCard.enter-in-line')}
          </Button>
        </form>
        {/* <a onClick={onPressBack}>Voltar</a> */}
        <S.Security>
          <Lock size={25} />
          <p>{t('@RemoteLineCreditCard.security-information')}</p>
        </S.Security>
      </S.Content>
    </>
  );
};
